import PubSub from "../../utils/PubSub";
import { removeFromFavorites } from "./removeFromFavorites";

export default function initializeFavoritesPage() {
  const favoritesContainer = document.querySelector(".favorites-items");
  if (!favoritesContainer) return;

  // Setup event listeners
  setupFavoriteItemsListeners();
  setupFavoritesEventSubscriptions();
}

function setupFavoriteItemsListeners() {
  const favoritesContainer = document.querySelector(".favorites-items");
  if (!favoritesContainer) return;

  favoritesContainer.addEventListener("click", (e) => {
    const removeButton = e.target.closest(".remove-item");
    if (!removeButton) return;

    const favoriteItem = e.target.closest(".favorite-item");
    if (!favoriteItem) return;

    e.preventDefault();
    const formData = new FormData();
    formData.append("product_id", favoriteItem.dataset.productId);
    removeFromFavorites(formData);
  });
}

function setupFavoritesEventSubscriptions() {
  PubSub.subscribe("fetch:removeFromFavorites:success", ({ data }) => {
    updateFavoritesUI(data.favorites);
    updateFavoritesCount(data.favorites_count);
  });

  PubSub.subscribe("fetch:removeFromFavorites:error", ({ error }) => {
    console.error("Remove from favorites error:", error);
  });
}

function updateFavoritesUI(favorites) {
  const container = document.querySelector(".favorites-items");
  const pageContainer = document.querySelector(".favorites-container");

  if (!container || !pageContainer) return;

  if (!favorites || favorites.length === 0) {
    pageContainer.innerHTML = `
      <div class="empty-favorites">
        <h2>${favoritesVars.texts.favoritesEmpty}</h2>
        <a href="${cartVars.shopUrl}" class="button">${favoritesVars.texts.shopNow}</a>
      </div>
    `;
    return;
  }

  container.innerHTML = favorites
    .map(
      (item) => `
      <div class="favorite-item" data-product-id="${item.id}">
        <a href="${item.url}" class="product-image">
          <img src="${item.image}" alt="${item.name}">
        </a>
        <div class="product-info">
          <h3>${item.name}</h3>
          <div class="price">${item.price}</div>
          ${
            !item.is_in_stock
              ? `<span class="out-of-stock">${favoritesVars.texts.outOfStock}</span>`
              : `<a href="${item.url}" class="go-to-product-button">
                  ${favoritesVars.texts.goToProduct}
                </a>`
          }
        </div>
        <button class="remove-item" aria-label="${
          favoritesVars.texts.removeFromFavorites
        }">×</button>
      </div>
    `
    )
    .join("");
}

function updateFavoritesCount(count = 0) {
  document.querySelectorAll(".favorites-count").forEach((el) => {
    el.textContent = count;
  });
}

// Initialize on DOM content loaded
document.addEventListener("DOMContentLoaded", initializeFavoritesPage);
